#import '../fragment/customerDocument.graphql'

query customerDocuments($customerId: ID!) {
  customerDocuments(customerId: $customerId) {
    ...customerDocumentFragment
  }
}
